/**
 * DocumentVersionEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { DocumentEntity } from "../DocumentEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { DocumentVersionEntity } from "../DocumentVersionEntity";
declare global {
    interface EntityTypeMap {
        DocumentVersion: DocumentVersionEntity;
    }
}
export abstract class DocumentVersionGeneratedEntity extends BaseEntity {
    public abstract documentVersionId: string;
    public abstract templateId: string | null;
    public abstract downloadPolicy: string;
    public abstract index: string;
    public abstract size: string;
    public abstract date: Date;
    public abstract filename: string;
    public abstract mimeType: string | null;
    public abstract document: DocumentEntity;
    public abstract activeForDocument: DocumentEntity | null;
    public abstract user: ProjectUserEntity | null;
}
